// A pagination policy that works with the Porpaginas API pagination response signature.
// see https://www.apollographql.com/docs/react/pagination/core-api/
// see https://www.apollographql.com/docs/react/caching/cache-field-behavior/
import { FieldPolicy } from '@apollo/client';

export const porpaginasOffsetPolicy = (): FieldPolicy => {
  return {
    keyArgs: false,
    merge(existing, incoming, { args }) {
      const offset = args?.offset || 0;
      const merged = existing ? existing.slice(0) : [];
      for (let i = 0; i < incoming.length; i++) {
        merged[offset + i] = incoming[i];
      }
      // Remove duplicates.
      for (let i = 0; i < merged.length; i++) {
        if (merged.find((el: never, idx: number) => idx !== i && JSON.stringify(el) === JSON.stringify(merged[i]))) {
          merged.splice(i, 1);
          i--;
        }
      }
      return merged;
    }
  };
};
